var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"law-cases-list",attrs:{"gutter":16,"type":"flex","align":"top"}},_vm._l((_vm.lawCases),function(lawCase){return _c('i-col',{key:lawCase.id,attrs:{"span":"24"}},[_c('law-cases-item',{attrs:{"law-case":lawCase,"all":_vm.all},on:{"open-law-case":_vm.openLawCase}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }